import styled from "styled-components";

export const SuggestionBoxStyled = styled.button`
  border-radius: 12px;
  background-color: #2a2e43;

  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  color: white;
  padding: 6px;
  height: 84px;

  & > div {
    flex-basis: 45%;
  }

  .max-weight {
    font-size: 0.667em;
    background-color: #404356;
    border-radius: 4px;
    padding: 1px 5px;
    margin-top: 16px;
  }

  .price-arrow {
    position: absolute;
    right: 5.1px;
    top: 2px;
  }
`;
